import Container from "Components/Container/Container";
import React from "react";
import { Link } from "react-router-dom";
import JobApplicationForm from "../JobApplicationForm/JobApplicationForm";

const Jobs = ({ data, jobsData }) => {
  const TruncateHtml = ({ htmlString, limit }) => {
    // Function to truncate text
    const truncateText = (html, charLimit) => {
      const div = document.createElement("div");
      div.innerHTML = html;
      const textContent = div.textContent || div.innerText || "";
      if (textContent.length > charLimit) {
        return textContent.substring(0, charLimit) + "...";
      }
      return textContent;
    };

    const truncatedHtml = truncateText(htmlString, limit);

    return (
      <div
        className="text-lg"
        dangerouslySetInnerHTML={{ __html: truncatedHtml }}
      />
    );
  };
  return (
    <section className="py-24 scroll-section-special">
      <Container>
        {data?.length !== 0 && (
          <>
            <h6 className="bebas text-5xl  lg:text-6xl lg:text-center text-white">
              Current jobs
            </h6>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mt-10 lg:mt-secondary">
              {data?.map(
                ({ date, job_title, short_description, slug }, index) => (
                  <div
                    className="text-white bg-[#212121] p-6 lg:py-8 lg:px-16 "
                    key={index}
                  >
                    <p>{date}</p>
                    <p className="text-4xl my-3 capitalize">{job_title}</p>
                    <TruncateHtml htmlString={short_description} limit={100} />

                    <Link
                      to={`/carrers_job_details/${slug}`}
                      className="text-font mt-10 block hover:underline"
                    >
                      View Details
                    </Link>
                  </div>
                )
              )}
            </div>
          </>
        )}

        <JobApplicationForm jobsData={jobsData} />
      </Container>
    </section>
  );
};

export default Jobs;
